import { useEffect, useRef } from 'react'

/**
 * Пока `active` — перехватывает системную кнопку «Назад» (Android) и браузерный
 * back: пушит фиктивную запись в history и на `popstate` зовёт `onBack` вместо
 * выхода из PWA. Если оверлей закрыли внутренним UI (скрим/кнопка), фиктивная
 * запись убирается из истории в cleanup.
 *
 * `onBack` держим в ref — эффект зависит только от `active`, поэтому inline-колбэк
 * не приводит к лишним pushState на каждый рендер.
 */
export const useBackButton = (active: boolean, onBack: () => void) => {
  const cb = useRef(onBack)
  cb.current = onBack

  useEffect(() => {
    if (!active) {
      return
    }
    window.history.pushState({ pwaBack: true }, '')
    let poppedByBack = false
    const onPop = () => {
      poppedByBack = true
      cb.current()
    }
    window.addEventListener('popstate', onPop)
    return () => {
      window.removeEventListener('popstate', onPop)
      // Закрыли не «Назад», а внутренним UI — снимаем нашу запись истории,
      // чтобы следующий системный back не был «съеден» пустым состоянием.
      if (!poppedByBack) {
        window.history.back()
      }
    }
  }, [active])
}
